import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  OutlinedInput,
  InputAdornment,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Select
} from '@mui/material';

import Page from '../../../components/Page';
import Label from '../../../components/Label';
import Scrollbar from '../../../components/Scrollbar';
import Iconify from '../../../components/Iconify';
import SearchNotFound from '../../../components/SearchNotFound';
import { UserListHead, UserMoreMenu } from '../../../sections/@dashboard/user';
import JSON_CONST from '../../../components/CONSTVALUE.json';
import Loader from '../../Loader/Loader';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: '*Transaction No', alignRight: false },
  { id: 'name', label: '*Bank Name', alignRight: false },
  { id: 'branch', label: '*Branch Name', alignRight: false },
  { id: 'customerName', label: '*Customer Name', alignRight: false },
  { id: 'date', label: 'Reg Date', alignRight: false },
  { id: 'phoneNo', label: '*Phone', alignRight: false },
  { id: 'applicationNo', label: '*App No', alignRight: false },
  { id: 'statusValue', label: '*Status', alignRight: false }
];

// ----------------------------------------------------------------------

export default function ListBT() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [selected, setSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [USERLIST, setUSERLIST] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [BankSearch, setBankSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [fromDataAutoFill, setFromDataAutoFill] = useState({
    bankList: [],
    branchList: [],
    userList: [],
    handledByList: []
  });

  const [isLoading, setIsLoading] = useState(true);

  // ---------------- Load Dropdown Lists ----------------
  const arrageList = (response) => {
    const list = [];
    response.data.forEach((row) => {
      if (row.status === 'true') {
        list.push(row);
      }
    });
    return list;
  };

  const loadDropdowns = async () => {
    try {
      const [banks, branches, users, handlers] = await Promise.all([
        axios.get(`${JSON_CONST.DB_URL}master/bank/list`),
        axios.get(`${JSON_CONST.DB_URL}master/branch/list`),
        axios.get(`${JSON_CONST.DB_URL}auth/userList`),
        axios.get(`${JSON_CONST.DB_URL}master/handledBy/list`)
      ]);

      setFromDataAutoFill({
        bankList: arrageList(banks),
        branchList: arrageList(branches),
        userList: arrageList(users),
        handledByList: arrageList(handlers)
      });
    } catch (err) {
      console.error(err);
    }
  };

  // ---------------- Load Data ----------------
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(`${JSON_CONST.DB_URL}disbursal/BT/list`);
  //     setUSERLIST(response.data);
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoading(false);
  //   }
  // };
  const fetchData = async (bankId = '') => {
    try {
      let url = `${JSON_CONST.DB_URL}disbursal/BT/list`;
      if (bankId) {
        url += `?bank=${bankId}`;
      }
      const response = await axios.get(url);
      setUSERLIST(response.data);
      setFilteredData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    loadDropdowns();
    fetchData();
  }, []);
  const banksearchList = (e) => {
    const query = e.target.value;
    setBankSearch(query);
    fetchData(query); // fetch bank wise data
  };
  // ---------------- Filtering Logic ----------------
  useEffect(() => {
    let data = USERLIST;

    // Apply search filter
    if (searchQuery) {
      data = data.filter((item) => {
        const searchString = `
          ${item.bankName?.name || ''} 
          ${item.id || ''} 
          ${item.branchName?.name || ''} 
          ${item.phoneNo || ''} 
          ${item.applicationNo || ''} 
          ${item.customerName || ''} 
          ${item.statusValue || ''}
        `.toLowerCase();
        return searchString.includes(searchQuery.toLowerCase());
      });
    }
    console.log("Filtering by Bank:", BankSearch);
    console.log("USERLIST sample:", USERLIST);

    // Apply bank filter
    if (BankSearch) {
      data = data.filter((row) => String(row.bankName?.id) === String(BankSearch));
    }

    setFilteredData(data);
  }, [USERLIST, searchQuery, BankSearch]);

  // ---------------- Event Handlers ----------------
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };



  const redirectPage = (url) => {
    if (url === 'homepage') {
      navigate(`/app/dashboard/`, { replace: true });
    } else {
      navigate(`/app/disbursal/bt/${url}`, { replace: true });
    }
  };

  const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
    width: 240,
    transition: theme.transitions.create(['box-shadow', 'width'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter
    }),
    '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
    '& fieldset': {
      borderWidth: `1px !important`,
      borderColor: `${theme.palette.grey[500_32]} !important`
    }
  }));

  // ---------------- Render ----------------
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0;
  const isUserNotFound = filteredData.length === 0;

  if (isLoading) return <Loader />;

  return (
    <Container maxWidth="">
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          BT ( Loan Take Over )
        </Typography>
        <Button
          variant="contained"
          onClick={() => redirectPage('newEntry/0')}
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          New Entry
        </Button>
      </Stack>

      <Card sx={{ width: '100%' }}>
        <Grid container alignItems="center" spacing={3} p={3}>
              <Grid item xs={12} sm={12} md={9} lg={9}>
                                  <SearchStyle
                                    style={{marginTop: '20px', marginLeft: '20px'}}
                                    value={searchQuery}
                                    onChange={handleInputChange}
                                    autoFocus
                                    // eslint-disable-next-line no-template-curly-in-string
                                    placeholder={`Search from " *yellow fields "`}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                                      </InputAdornment>
                                    }
                                  />
                                </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="Bank-select-label">Bank</InputLabel>
              <Select
                labelId="Bank-select-label"
                id="Bank-select"
                value={BankSearch}
                onChange={banksearchList}
              >
                <MenuItem value="">All</MenuItem>
                {fromDataAutoFill.bankList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 100 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={USERLIST.length}
                numSelected={selected.length}
              />
              <TableBody>
                {filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const { id, bankName, branchName, customerName, registrationDate, phoneNo, applicationNo, statusValue, avatarUrl } = row;
                    return (
                      <TableRow hover key={id}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {avatarUrl && <Avatar alt={bankName?.name} src={avatarUrl} />}
                            <Typography variant="subtitle2" noWrap>
                              {bankName?.name}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{branchName?.name}</TableCell>
                        <TableCell align="left">{customerName}</TableCell>
                        <TableCell align="left">{registrationDate}</TableCell>
                        <TableCell align="left">{phoneNo}</TableCell>
                        <TableCell align="left">{applicationNo}</TableCell>
                        <TableCell align="left">
                          <Label variant="ghost" color={'secondary'}>
                            {statusValue || 'NA'}
                          </Label>
                        </TableCell>
                        <TableCell align="right">
                          <UserMoreMenu
                            urlTo={'/app/disbursal/bt/newEntry/'}
                            data={row}
                            dataID={id}
                            deleteURL={'disbursal/BT/delete/'}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}

                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>

              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={searchQuery} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5,10, 25, 50, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
